import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_ArtifactSyncer = {
    getArtifact: {
        path: 'v1/artifact-syncer/get-artifact',
        method: HttpMethod.POST,
        timeout: 3 * Minute,
    }
};
//# sourceMappingURL=api-def.js.map